import { useEffect, useRef } from 'react';
const TypewriterEffect = () => {
  const textRef = useRef(null);

  useEffect(() => {
    const textElement = textRef.current;
    const textContent = textElement.textContent;

    textElement.textContent = ''; // 清空原始文字內容

    let index = 0;

    const type = () => {
      if (index < textContent.length) {
        textElement.textContent += textContent.charAt(index);
        index++;
        setTimeout(type, 50); // 設定打字速度
      }
    };

    type();
  }, []);

  return (
    <div className="loading-animation">
    <div className="loading-text">
      <span ref={textRef}>Chiioa</span>
    </div>
  </div>
  );
};

export default TypewriterEffect;
